import { render } from "./ManangeOpportunity.vue?vue&type=template&id=81809ca0&scoped=true"
import script from "./ManangeOpportunity.vue?vue&type=script&lang=js"
export * from "./ManangeOpportunity.vue?vue&type=script&lang=js"

import "./ManangeOpportunity.vue?vue&type=style&index=0&id=81809ca0&scoped=true&lang=css"

import exportComponent from "/var/www/admin_web_aaac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81809ca0"]])

export default __exports__